module.exports = __webpack_public_path__ + "img/MTCNA.8c56f9b2.png";